@import '../../utils/global.module.less';

.backButton {
    position: absolute;
    top: -2px;
    z-index: 80000;
    transition: opacity 0.4s ease-in-out;
    transition-delay: 0.35s;
    img {
        position: relative;
        top: -3px;
        margin-right: 8px;
        width: 18px;
        height: 18px;
    }

    button {
        transform-origin: center;
        font-family: Hanken Grotesk;
        font-weight: 400;
        border: none;
        background-color: transparent !important;
        margin: 8px;
        padding: 6px 6px;
        border-radius: 0;
        border-bottom: 2px solid transparent;
    }
    button:hover {
        border-bottom: 2px solid rgba(147, 124, 40, 0.63);
    }
}

.switchView {
    position: absolute;
    width: 100%;
    height: 100%;
    transition: opacity 0.6s ease-in-out;
}
